type PaginationService = {
  createEmptySlots: ({ totalItemsCount, pageSize }: { totalItemsCount: number; pageSize: number }) => number[];
};

const makePaginationService = (): PaginationService => {
  const createEmptySlots = ({ totalItemsCount, pageSize }: { totalItemsCount: number; pageSize: number }) => {
    const lastPageItemCount = totalItemsCount % pageSize;
    const emptyItemsCount = lastPageItemCount > 0 ? pageSize - lastPageItemCount : 0;

    return Array.from({ length: emptyItemsCount }, (_, index) => index);
  };

  return { createEmptySlots };
};

export const PaginationService = makePaginationService();
